/**
 * Operator teacher-account list and delete (`/chat/admin/teachers…`).
 */
import type { AdminTeacherListResponse, AdminTeacherSummaryWire } from '../types/backend';
import { DOMAIN_ERROR_MESSAGES_DA } from '../types/backend';
import { nowISO } from '../lib/ids';
import type { TeacherAccount } from '../types';
import { ApiError, USE_LIVE, encodeApiSegment, fetchJson, mapAdminError } from './http';

const ADMIN_LIST_ERROR_MESSAGE = 'Kunne ikke hente lærere.';
const ADMIN_DELETE_ERROR_MESSAGE = 'Kunne ikke slette læreren.';

const mockTeacherAccounts: TeacherAccount[] = [
  {
    id: 'mock-teacher-1',
    email: 'laerer@skole.dk',
    displayName: 'Mock Lærer',
    createdAt: nowISO(),
  },
  {
    id: 'mock-teacher-2',
    email: 'anden@skole.dk',
    displayName: null,
    createdAt: nowISO(),
  },
];

function wireToAccount(wire: AdminTeacherSummaryWire): TeacherAccount {
  return {
    id: wire.id,
    email: wire.email,
    displayName: wire.display_name,
    createdAt: wire.created_at,
  };
}

export async function listTeacherAccounts(): Promise<TeacherAccount[]> {
  if (!USE_LIVE) {
    return mockTeacherAccounts.map((row) => ({ ...row }));
  }
  try {
    const data = await fetchJson<AdminTeacherListResponse>('/chat/admin/teachers', { admin: true });
    return data.teachers.map(wireToAccount);
  } catch (error) {
    throw mapAdminError(error, ADMIN_LIST_ERROR_MESSAGE);
  }
}

export async function deleteTeacherAccount(id: string): Promise<void> {
  if (!USE_LIVE) {
    const index = mockTeacherAccounts.findIndex((row) => row.id === id);
    if (index === -1) {
      throw new ApiError({
        httpStatus: 404,
        code: 'teacher_not_found',
        userMessage: DOMAIN_ERROR_MESSAGES_DA.teacher_not_found,
      });
    }
    mockTeacherAccounts.splice(index, 1);
    return;
  }

  try {
    await fetchJson<void>(`/chat/admin/teachers/${encodeApiSegment(id)}`, {
      method: 'DELETE',
      admin: true,
    });
  } catch (error) {
    throw mapAdminError(error, ADMIN_DELETE_ERROR_MESSAGE);
  }
}
